if (!customElements.get("load-listings")) {
  customElements.define(
    "load-listings",
    class LoadListings extends HTMLElement {
      constructor() {
        super();
        //console.log("university mounted");
        this.pInfScrLoading = false;
        this.pInfScrDelay = 100;
        this.loadMore = this.querySelector("[data-load-more]");
        this.bindClickEvent();
      }

      bindClickEvent() {
        this.loadMore?.addEventListener("click", this.handleClick.bind(this));
      }

      handleClick(event){
        //console.log("Click attached!");

        event.preventDefault();
        this.pInfScrExecute(this.loadMore);
        return false;
        
      }

      pInfScrExecute(loadMore) {
        //console.log(loadMore);
        let pInfScrNode = loadMore;
        let pInfScrURL = loadMore.href;
        //console.log(pInfScrURL);
        const listingWrapper = document.querySelector("[data-listing-wrapper]");

        // Set loading state
        pInfScrNode.innerHTML = "Loading...";

        if (pInfScrNode) {
          // Without jQuery
          fetch(pInfScrURL, {
            method: "GET",
          })
            .then(function (response) {
              // The API call was successful!
              return response.text();
            })
            .then(function (html) {
              // Convert the HTML string into a document object
              let parser = new DOMParser();
              let doc = parser.parseFromString(html, "text/html");

              // Get the listings and append them to the list
              let listingContainer = doc.querySelectorAll(
                "[data-listing-container]"
              );
              //console.log(listingWrapper);
              for (let i = 0; i < listingContainer.length; i++) {
                //console.log(listingContainer[i])
                listingWrapper.appendChild(listingContainer[i]);
              }

              //Get the paginate link and replace it or remove current
              let newloadMore = doc.querySelector("[data-load-more]");
              if (newloadMore) {
                let newloadMoreHref = newloadMore.getAttribute("href");
                pInfScrNode.href = newloadMoreHref;
                pInfScrNode.innerHTML = "View More";
              } else {
                //hide loadmore
                pInfScrNode.remove();
              }
            })
            .catch(function (err) {
              // There was an error
              console.warn("Something went wrong.", err);
            });
        }
      }
    }
  );
}
